<p>
  info-cost-out works!
</p>
